import {
  FETCHING_USER_GROUPS,
  FETCHING_USER_GROUPS_SUCCEEDED,
  FETCHING_USER_GROUPS_FAILED,
} from "constants/actionTypes.jsx";

import axios from "axios";
import buildUrl from "build-url";
import { createAction } from "redux-actions";
import { call, put, takeLatest } from "redux-saga/effects";

const API_URL = process.env.REACT_APP_API_URL;
const USER_GROUPS_BASE_URL = `${API_URL}/api/1.0/user_groups`;

/** fetch user groups */
export const fetchUserGroups = createAction(FETCHING_USER_GROUPS);
const fetchingUserGroupsSucceeded = createAction(
  FETCHING_USER_GROUPS_SUCCEEDED
);
const fetchingUserGroupsFailed = createAction(FETCHING_USER_GROUPS_FAILED);

function* fetchUserGroupsSaga(action) {
  let { account, limit } = action.payload;

  let url = buildUrl(USER_GROUPS_BASE_URL, { path: "/search" });
  const fetchUserGroupsAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: { account, limit },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchUserGroupsAPI);
    yield put(fetchingUserGroupsSucceeded(response));
  } catch (error) {
    yield put(fetchingUserGroupsFailed(error));
  }
}

export default function* userGroupsSaga() {
  yield takeLatest(FETCHING_USER_GROUPS, fetchUserGroupsSaga);
}
